import { CombinedGraphQLErrors, ErrorLike } from '@apollo/client'
import { isErrorLike } from '@apollo/client/errors'
import { useMemo } from 'react'

type Props = {
  error?: ErrorLike | null
  messageTranslations?: Record<string, string>
}

export function ApolloErrorMessage({ error, messageTranslations }: Props) {
  const messages = useMemo(() => {
    if (!error) return []

    if (CombinedGraphQLErrors.is(error)) {
      return error.errors.map(error => error.message)
    }

    if (isErrorLike(error)) {
      return [error.message]
    }

    return []
  }, [error])

  if (!error) return null

  return (
    <div className="flex flex-col gap-1">
      {messages.map(function (msg, idx) {
        return (
          <span
            className="pl-2 text-regular text-red-500"
            role="alert"
            key={idx}
          >
            {messageTranslations?.[msg] ?? msg}
          </span>
        )
      })}
    </div>
  )
}
